import { apiInstance, gql } from "@/services/httpAdapter.ts";

// Types
import { IPaginatedResponse } from "@Common/api/types/pagination";
import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";

// Fragments
import { TitlingFragment } from "./fragments.ts";

// Helpers
import { errorLogger } from "@Common/helpers/logger.ts";

export async function getTitlings(args: {
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	first: number;
	after: string;
}) {
	const { locationId, commissionCycleId, payPeriodId, first = 1000, after = "" } = args;

	const query = gql`
		query getTitlings($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!, $pagination: PaginationInput) {
			getTitlings(
				locationId: $locationId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				pagination: $pagination
			) {
				edges {
					cursor
					node {
						...Titling
					}
				}
				pageInfo {
					endCursor
					hasNextPage
					totalCount
				}
			}
		}
		${TitlingFragment}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
		pagination: {
			first,
			after: after ?? "",
		},
	};

	try {
		const response: GraphqlQueryResponse<"getTitlings", IPaginatedResponse<object>> = await apiInstance.post("/graphql", {
			query,
			variables,
		});
		return response.data.data?.getTitlings;
	} catch (err) {
		errorLogger(err as Error, { function: "getTitlings", message: "Failed to get F&I Details", variables });
		return null;
	}
}
